import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button, Skeleton } from "@mui/material";
import { Brand, Hero } from "../../api/homepage";
import { sendCustomEvents } from "../../ga";
interface BannerProps {
  scrollToProducts: () => void;
  data?: Hero;
  brandInfo?: Brand;
}

const Banner: React.FC<BannerProps> = ({
  brandInfo,
  data,
  scrollToProducts,
}) => {
  const navigate = useNavigate();
  const orgId = localStorage.getItem("orgId");
  return (
    <>
      {!brandInfo?.backgroundImageUrl ? (
        <Skeleton
          variant="rectangular"
          data-testid="skeleton-loader"
          role="progressbar"
          sx={{
            height: "80vh",
            display: { xs: "none", sm: "flex" },
            alignItems: "center",
            justifyContent: "flex-start",
            backgroundSize: "cover",
            backgroundPosition: "center",
            color: "#fff",
            padding: "0 50px",
            margin: "17px",
            fontFamily: "Poppins, sans-serif",
          }}
        />
      ) : (
        <Box
          sx={{
            position: "relative",
            height: "80vh",
            display: { xs: "none", sm: "flex" },
            alignItems: "center",
            justifyContent: "flex-start",
            backgroundImage: `url(${brandInfo?.backgroundImageUrl})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            color: "#fff",
            padding: "0 50px",
            margin: "17px",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1,
            }}
          ></Box>

          <Box
            sx={{
              zIndex: 2,
              maxWidth: "850px",
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontSize: "16px",
                marginBottom: "10px",
                fontFamily: "Poppins, sans-serif",
                fontWeight: 500,
              }}
            >
              {data?.heading1 ?? ""}
            </Typography>
            <Typography
              variant="h2"
              sx={{
                fontWeight: "bold",
                fontSize: "37px",
                marginBottom: "20px",
                fontFamily: "Poppins, sans-serif",
                lineHeight: "50px",
              }}
            >
              {data?.heading2 ?? ""}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                marginBottom: "30px",
                fontSize: "17px",
                fontFamily: "Poppins, sans-serif",
                fontWeight: 400,
              }}
            >
              {data?.body1 ?? ""}
            </Typography>
            <Box sx={{ display: "flex", gap: "20px" }}>
              <Button
                variant="outlined"
                sx={{
                  color: "#fff !important",
                  fontFamily: "Poppins, sans-serif",
                  borderRadius: "16px",
                  fontSize: "16px",
                  textTransform: "none",
                  padding: "14px 0px",
                  borderColor: "white !important",
                  width: "178px",
                  height: "48px",
                  "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.2)" },
                }}
                onClick={() => {
                  sendCustomEvents(
                    "Customer",
                    "Clicked Explore Beers",
                    "explore button in Homepage"
                  );
                  scrollToProducts();
                }}
              >
                Explore Our Beers
              </Button>

              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#fff",
                  color: "#000",
                  fontFamily: "Poppins, sans-serif",
                  textTransform: "none",
                  borderRadius: "16px",
                  width: "178px",
                  height: "48px",
                  "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.8)" },
                }}
                onClick={() => {
                  sendCustomEvents(
                    "Customer",
                    "Clicked buy from us",
                    "buy button in HomePage"
                  );
                  navigate(`/${orgId}/customer/products`);
                }}
              >
                Buy From Us<span style={{ margin: 6 }}>&gt;</span>
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default Banner;
